import { TagLink } from '@bnnvara/tags';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import Link from '../Link';
import { ThemeTagArticle } from '../Tags/ThemeTagArticle';

import TagTitle from './styled';

export const tagPropType = PropTypes.shape({
  slug: PropTypes.string,
  name: PropTypes.string,
});

const TagList = ({ tags, subThemes }) => {
  if (tags.length === 0 && subThemes.length === 0) {
    return null;
  }
  const hideOnProduction = process.env.NODE_ENV !== 'production';

  return (
    <>
      {subThemes.length > 0 && hideOnProduction && (
        <div>
          <TagTitle>Thema&apos;s:</TagTitle>
          {subThemes.map((subTheme, index) => (
            <Fragment key={`fragment-${subTheme.slug}`}>
              <ThemeTagArticle
                themeSlug={subTheme.parentSlug}
                size="sm"
                href={`/thema/${subTheme.parentSlug}/${subTheme.slug}`}
              >
                {subTheme.name}
              </ThemeTagArticle>
              <span key={`comma-${subTheme.name}`}>
                {index < subThemes.length - 1 ? (
                  <span>&nbsp; &bull; &nbsp;</span>
                ) : null}
              </span>
            </Fragment>
          ))}
        </div>
      )}
      {tags.length > 0 && (
        <div>
          <TagTitle>Meer over:</TagTitle>
          {tags.map((tag, index) => (
            <Fragment key={`fragment-${tag.slug}`}>
              <Link
                href={`/tags/${tag.slug}`}
                category="Zoeken"
                label={`tags-${tag.slug}`}
                action="click"
                key={`link-${tag.slug}`}
              >
                <TagLink key={tag.slug}>{tag.name}</TagLink>
              </Link>
              <span key={`comma-${tag.slug}`}>
                {index < tags.length - 1 ? ', ' : null}
              </span>
            </Fragment>
          ))}
          {tags.length > 0 && (
            <span key={`comma-${tags[tags.length - 1].name}`}>{', '}</span>
          )}
        </div>
      )}
    </>
  );
};

TagList.defaultProps = {
  tags: [],
};

TagList.propTypes = {
  tags: PropTypes.arrayOf(tagPropType),
  subThemes: PropTypes.arrayOf(PropTypes.shape()),
};

export default TagList;
